import { render, staticRenderFns } from "./role_info.vue?vue&type=template&id=2e2068ca&scoped=true&"
import script from "./role_info.vue?vue&type=script&lang=js&"
export * from "./role_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2068ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2068ca')) {
      api.createRecord('2e2068ca', component.options)
    } else {
      api.reload('2e2068ca', component.options)
    }
    module.hot.accept("./role_info.vue?vue&type=template&id=2e2068ca&scoped=true&", function () {
      api.rerender('2e2068ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/roles/row/tabs/role_info.vue"
export default component.exports